import {
  prop
} from "ramda";
import app from "./app";

app
  .factory("SecurityReportsPersistence", SecurityReportsPersistence);

function SecurityReportsPersistence($http) {
  function get(url) {
    return $http
      .get(`${url}?time=${Date.now()}`, {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      })
      .then(prop("data"));
  }

  return {
    get: get,
  };
}
